module.exports = __webpack_public_path__ + "img/unconfirm-pop.52e20626.png";